import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Typography,
    Stack,
    Grid,
    List,
    ListItem,
    Link,
    ImageList,
    ImageListItem,
    Tooltip
} from '@mui/material';


import FilterLogo from './assets/icons/filterIcon.svg';
import CloseLogo from "./assets/icons/close.svg";

import {
    uberuGreenColor,
    uberuLightGreenColor,
    apiURL,
    uberuLightGreen2Color,
    uberuRedColor,
    uberuLightColor,
    uberuTextColor,
    uberuLightColor2,
    uberuBorderColor,
    uberuPointTypes,
    uberuWasteTypes
} from './Constants'
import axios from 'axios';

// import './assets/css/mycss.css';
import "@fontsource/manrope";
import '@fontsource/manrope/200.css';
import '@fontsource/manrope/300.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}


const FiltersUberu = (props) => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [filterIsActive, setFilterIsActive] = useState(false);
    const isMountingRef = useRef(false);
    const [pointTypesSelected, setPointTypesSelected] = useState([]);
    const [wasteTypesSelected, setWasteTypesSelected] = useState([]);
    const [initialPointTypes, setInitialPointTypes] = useState([]);
    const [initialWasteTypes, setInitialWasteTypes] = useState([]);

    useEffect(() => {
        isMountingRef.current = true;
        if(props.show == false)
            setFilterIsActive(false)
    }, [props])

    useEffect(() => {
        if(props.initialWasteTypes != initialWasteTypes && props.initialWasteTypes.length >= 1)
        {
            setInitialWasteTypes(props.initialWasteTypes)
            var wasteTypesSelectedTemp = uberuWasteTypes.filter(p =>  props.initialWasteTypes.includes(p.NameDb) || props.initialWasteTypes.includes(p.Name)).map(p => p.Name)
            if (wasteTypesSelectedTemp.length >= 1)
            {
                setWasteTypesSelected(wasteTypesSelectedTemp)
            }
            // updateFilterParent([], wasteTypesSelectedTemp)
        }
    }, [props.initialWasteTypes])

    useEffect(() => {
        if(props.initialPointTypes != initialPointTypes && props.initialPointTypes.length >= 1)
        {
            setInitialPointTypes(props.initialPointTypes)
            var pointTypesSelectedTemp = uberuPointTypes.filter(p =>  props.initialPointTypes.includes(p.Id.toString())).map(p => p.Id)
            if (pointTypesSelectedTemp.length >= 1)
            {
                setPointTypesSelected(pointTypesSelectedTemp)
            }
            // updateFilterParent(pointTypesSelectedTemp, [])
        }
    }, [props.initialPointTypes])

    const selectPointType = (type, update) => {
        let pointTypesSelectedTemp = pointTypesSelected;
        if (pointTypesSelected.includes(type)) 
            pointTypesSelectedTemp = pointTypesSelected.filter(p => p != type)
        else 
            pointTypesSelectedTemp = pointTypesSelected.concat(type)
        setPointTypesSelected(pointTypesSelectedTemp)
        if(update)
            updateFilterParent(pointTypesSelectedTemp, wasteTypesSelected)
    }

    const selectWasteType = (type, update) => {
        let wasteTypesSelectedTemp = wasteTypesSelected;
        if (wasteTypesSelected.includes(type)) 
            wasteTypesSelectedTemp = wasteTypesSelected.filter(p => p != type)
        else 
            wasteTypesSelectedTemp =  wasteTypesSelected.concat(type)
        setWasteTypesSelected(wasteTypesSelectedTemp)
        if(update)
            updateFilterParent(pointTypesSelected, wasteTypesSelectedTemp)
    }

    const clearFilters = (type) => {
        setPointTypesSelected([])
        setWasteTypesSelected([])
        updateFilterParent([],[])
    }

    
    // useEffect(() => {
    //         updateFilterParent(pointTypesSelected, wasteTypesSelected)
    // }, [pointTypesSelected, wasteTypesSelected])

    const updateFilterParent = (types, wastes)=>{
        props.onUpdate({
            types,
            wastes
        })
    }
 

    return (
        <>
        {!props.hidden
        ?<Grid
            container
            style={{
                verflowY: "scroll", 
                height: "80px", 
                position: "absolute",
                top: "3vh",
                left: "2vw",
                cursor: 'pointer'
            }}>
            {!filterIsActive
                ?
                <Grid
                    container
                    style={{
                        position: "absolute",
                        cursor: 'pointer'
                    }}>
                    <Grid
                        item
                        xs={11}
                        lg={11}
                        md={11} 
                        >
                        <Grid container>
                            <Grid
                                item
                                xs={2}
                                lg={1}
                                md={1}>
                                <Box 
                                    onClick={() => {setFilterIsActive(true); props.onOpen()}}
                                >
                                    <img src={FilterLogo} alt='Filter Logo' width='80px' height='80px'/>
                                    {pointTypesSelected.length + wasteTypesSelected.length >0
                                    &&
                                    <Box sx={{
                                        position: "absolute",
                                        left: "50px",
                                        top: "10px",
                                        width: "23px",
                                        height: "23px",
                                        borderRadius: 20,
                                        backgroundColor: uberuRedColor,
                                        textAlign: "center"
                                    }}>
                                        <Typography variant="subtitle2" fontWeight={700} fontFamily="Manrope"   color="white">
                                            {pointTypesSelected.length + wasteTypesSelected.length}
                                        </Typography>
                                    </Box>}
                                </Box>
                            </Grid>
                            {window.innerWidth > 600 &&
                            <Grid
                                item
                                xs={10}
                                lg={11}
                                md={11}>
                                <Grid
                                container>
                                {pointTypesSelected.map((item) =>
                                    <Box
                                        key={item}
                                        sx={{
                                            backgroundColor: "white",
                                            border: 1,
                                            borderColor: uberuBorderColor,
                                            py: 1,
                                            px: 2,
                                            my: 1,
                                            mr: 1,
                                            height: "45px",
                                            borderRadius: 10,
                                        }}
                                    >
                                        <Typography variant="body" fontWeight={400} fontFamily="Manrope" color={uberuTextColor} pr={1}>
                                            {uberuPointTypes.filter(p => p.Id == item)[0].Name}
                                        </Typography>
                                        <img src={CloseLogo} height={20} width={20} style={{cursor: 'pointer'}} onClick={() => selectPointType(item, true)}/>
                                    </Box>
                                )}
                                {wasteTypesSelected.map((item) =>
                                    <Box
                                        key={item}
                                        sx={{
                                            backgroundColor: "white",
                                            border: 1,
                                            borderColor: uberuBorderColor,
                                            py: 1,
                                            px: 2,
                                            my: 1,
                                            mr: 1,
                                            height: "45px",
                                            borderRadius: 10,
                                        }}
                                    >
                                        <Typography variant="body" fontWeight={400} fontFamily="Manrope" color={uberuTextColor} pr={1}>
                                            {uberuWasteTypes.filter(p => p.Name == item)[0] != undefined && uberuWasteTypes.filter(p => p.Name == item)[0].Description}
                                        </Typography>
                                        <img src={CloseLogo} height={20} width={20} style={{cursor: 'pointer'}} onClick={() => selectWasteType(item, true)}/>
                                    </Box>
                                )}
                                </Grid>
                            </Grid>}
                        </Grid>
                    </Grid>
                </Grid>
                : <Grid
                    container
                    style={{
                        position: "absolute",
                        top: "3vh",
                        left: "2vw"
                    }}>
                    <Grid
                        item
                        xs={11}
                        lg={3}
                        md={6} 
                        >
                        <Stack direction="row">
                        <Box
                            flex={1}
                            overflow="auto"
                            style={{
                                backgroundColor: "white",
                                borderRadius: 20,
                                maxHeight: "90vh"
                            }}
                        >
                            <Box p={2}>
                                <Grid container py={1}>
                                    <Grid container py={1}>
                                        <Grid item  xs={11}>  
                                        <Typography variant="h6" fontWeight={700} fontFamily="Manrope" lineHeight={1}>
                                            Тип пункта
                                        </Typography>
                                    </Grid> 
                                    <Grid item xs={1} onClick={props.onHide} sx={{cursor: "pointer"}} alignItems="" justifyContent="center">
                                            <img src={CloseLogo} height={24} width={24}/>
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        {uberuPointTypes.map((item) =>
                                            <Box
                                                key={item.Id}
                                                sx={{
                                                    backgroundColor: pointTypesSelected.includes(item.Id) ? uberuGreenColor : uberuLightColor,
                                                    border: 2,
                                                    borderColor: pointTypesSelected.includes(item.Id) ? uberuLightColor2 : uberuLightColor,
                                                    py: 0.5,
                                                    px: 1,
                                                    my: 0.5,
                                                    mr: 1,
                                                    borderRadius: 10,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => selectPointType(item.Id, false)}
                                            >
                                                <Typography variant="body" fontWeight={400} fontFamily="Manrope" color={pointTypesSelected.includes(item.Id) ? "white" : uberuTextColor}>
                                                    {item.Name}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container py={1}>
                                    <Grid py={1}>
                                        <Typography variant="h6" fontWeight={700} fontFamily="Manrope" lineHeight={1}>
                                            Тип принимаемых отходов
                                        </Typography>
                                    </Grid>
                                    <Grid container>
                                        {uberuWasteTypes.map((item) =>
                                            <Box
                                                key={item.Id}
                                                sx={{
                                                    backgroundColor: wasteTypesSelected.includes(item.Name) ? uberuGreenColor : uberuLightColor,
                                                    border: 2,
                                                    borderColor: wasteTypesSelected.includes(item.Name) ? uberuLightColor2 : uberuLightColor,
                                                    py: 0.5,
                                                    px: 1,
                                                    my: 0.5,
                                                    mr: 1,
                                                    borderRadius: 10,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => selectWasteType(item.Name, false)}
                                            >
                                                <Typography variant="body" fontWeight={400} fontFamily="Manrope" color={wasteTypesSelected.includes(item.Name) ? "white" : uberuTextColor}>
                                                    {item.Description}
                                                </Typography>
                                            </Box>
                                        )}
                                        
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <Box
                                            sx={{
                                                border: 2,
                                                borderColor: uberuGreenColor,
                                                py: 0.5,
                                                px: 1,
                                                my: 1,
                                                mr: 1,
                                                w: "100%",
                                                borderRadius: 5,
                                                cursor: 'pointer'
                                            }}
                                            textAlign="center"
                                            onClick={() => clearFilters()}
                                        >
                                            <Typography variant="subtitle1" fontWeight={600} fontFamily="Manrope" color={uberuGreenColor}>
                                                Очистить
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box
                                            sx={{
                                                border: 2,
                                                borderColor: uberuGreenColor,
                                                backgroundColor: uberuGreenColor,
                                                py: 0.5,
                                                px: 1,
                                                my: 1,
                                                mr: 1,
                                                w: "100%",
                                                borderRadius: 5,
                                                cursor: 'pointer'
                                            }}
                                            textAlign="center"
                                            onClick={() => {setFilterIsActive(false); updateFilterParent(pointTypesSelected, wasteTypesSelected)}}
                                        >
                                            <Typography variant="subtitle1" fontWeight={600} fontFamily="Manrope" color="white">
                                                Применить
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Stack>
                    </Grid>
                </Grid>
            }
        </Grid>
        :<></>}
        </>
    );
}

export default FiltersUberu;